import Image from 'next/image'
import { FC } from 'react'

import { cn } from '@/app/utils'
import { CreateRequestButton } from '@/components/entities/requests/ui/CreateRequestButton'
import EmptyListPlug from '@/components/pages/plugs/EmptyListPlug'

type Props = {
  areRequestsEmpty: boolean
  isCreateButton?: boolean
}

const EmptyRequestsPlug: FC<Props> = ({
  areRequestsEmpty,
  isCreateButton = false
}) => {
  const title = areRequestsEmpty ? 'У вас нет обращений' : 'Ничего не нашлось'

  return (
    <div
      className={
        isCreateButton
          ? 'flex flex-col gap-40 py-63 sm:gap-20 sm:pb-0 sm:pt-20'
          : undefined
      }
    >
      <EmptyListPlug
        title={title}
        description={
          areRequestsEmpty ? (
            <span>
              Заказывайте услуги, задавайте вопросы или оставляйте <br /> отзывы
              в Службе комфорта Sminex
            </span>
          ) : (
            'Попробуйте изменить параметры поиска или сбросить фильтры'
          )
        }
        className={cn(
          'mt-0 flex h-[48vh] flex-1 items-center justify-center',
          isCreateButton && 'h-auto xs:mt-0'
        )}
        image={
          <Image
            src={
              areRequestsEmpty
                ? '/images/shared/BlankSheet.png'
                : '/images/shared/MagnifyingGlass.png'
            }
            alt={title}
            height={100}
            width={100}
          />
        }
        titleClassName="lg:text-24 sm:text-16"
        descriptionClassName="!text-16 sm:!text-12 text-grey-60"
      />
      {isCreateButton && (
        <div className="flex w-full justify-center">
          <CreateRequestButton size="medium" />
        </div>
      )}
    </div>
  )
}

export { EmptyRequestsPlug }
